<template>
    <FormWrapper :is-loading="isLoading">
        <PageTitle title="To Do List" slot="title" link="/helpContent/To Do List" />
        <DataTable :actions="true"
            :data="toDoList"
            :columns="tableConfig"
            :is-loading="isLoading"
            @on-selection-change="selectChange"
            @on-page-change="pageChange"
            :pagination="pagination"
            @on-sort-change="sortChange">
            <template slot="actionsLeft">
                <TableButton @click="() => edit()">
                    <img :src="require(`Assets/images/view.png`)"/>
                  View
                </TableButton>
            </template>
        </DataTable>
        <Popup title="Information" :value="warningModal.visible" @close="() => showWarningModal(false)">
            {{ warningModal.message }}
            <div slot="footer">
                <FormButton v-if="warningModal.buttons.ok" @click="() => showWarningModal(false)">Ok</FormButton>
            </div>
        </Popup>
    </FormWrapper>
</template>

<script>
    import FormWrapper from 'Components/form/FormWrapper';
    import PageTitle from 'Components/layout/PageTitle';
    import DataTable from 'Components/DataTable'
    import loadingMixin from 'Mixins/loadingMixin'
    import validateSelectedRows from "Mixins/validateSelectedRows";
    import {getToDoList} from '../api'
    import tableConfig from './table'
    export default {
        name: "List",
        mixins: [loadingMixin, validateSelectedRows],
        components: {
            FormWrapper,
            DataTable,
            PageTitle
        },
        data() {
            return {
                sorting: {
                    key: 'deadline',
                    order: 'desc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                toDoList: [],
                selectedRows: []
            }
        },
        computed: {
          userData() {
              return this.$store.state.user.user
            }
        },
        watch: {
        },
        created() {
            this.getData()
        },
        methods: {
            edit(){
                if (this.validateSelectedLength(1)) {
                    if (this.selectedRows[0].ToDoType === 'LeaveRequest') { //TO BE DONE (MAHIMA)
                        this.$router.push({ path: `/leaveApprove/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    } 
                    else if (this.selectedRows[0].ToDoType === 'LeaveApprovalStatus') {
                        this.$router.push({ path: `/applyForLeave/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    //DELETE
                    else if (this.selectedRows[0].ToDoType === 'LeaveDeleteApproval') {//TO BE DONE (MAHIMA)
                        this.$router.push({ path: `/leaveApprove/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'LeaveODApproval') {
                        this.$router.push({ path: `/applyOD/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'LeaveRequestSL') {
                        this.$router.push({ path: `/applyForShortLeave/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'LeaveResubmit') {
                        this.$router.push({ path: `/applyForLeave/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'Expense Request') {
                        this.$router.push({ path: `/approveClaim/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'Expense Resubmit Req') {
                        this.$router.push({ path: `/expenseClaim/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'Missed Punch Request') { //TO BE DONE (MAHIMA)
                        this.$router.push({ path: `/addMissedPunch/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'TaskAssigned') {
                        this.$router.push({ path: `/taskDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/ta` }); //TaskType=ta
                    }
                    else if (this.selectedRows[0].ToDoType === 'TaskDone') {
                        this.$router.push({ path: `/taskDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/td` }); //TaskType=td
                    }
                    else if (this.selectedRows[0].ToDoType === 'TaskPending') {
                        this.$router.push({ path: `/taskDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/tp` }); //TaskType=tp
                    }
                    else if (this.selectedRows[0].ToDoType === 'TaskComplete') {
                        this.$router.push({ path: `/taskDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/tc` }); //TaskType=tc
                    }
                    else if (this.selectedRows[0].ToDoType === 'OPFApproval') {
                        this.$router.push({ path: `/OPF/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/tc` }); //TaskType=tc
                    }
                    else if (this.selectedRows[0].ToDoType === 'OPFRejected') {
                        this.$router.push({ path: `/OPF/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/tc` }); //TaskType=tc
                    }
                    else if (this.selectedRows[0].ToDoType === 'AllocatePM') {
                        this.$router.push({ path: `/allocatePM/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/tc` }); //TaskType=tc
                    }
                    else if (this.selectedRows[0].ToDoType === 'InvoiceRequest') {
                        this.$router.push({ path: `/invoiceDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'CreateMileStone') {
                        this.$router.push({ path: `/createMileStone/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'SeparationProcess') {
                        this.$router.push({ path: `/resignApprove/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'SalaryReleaseRequest') {
                        this.$router.push({ path: `/releaseSalaryDetail/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'ChangeNoticeApproval') {
                        this.$router.push({ path: `/changeNotice/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/true/tc` });
                    } 
                    else if (this.selectedRows[0].ToDoType === 'ChangeNoticeRejected') {
                        this.$router.push({ path: `/changeNotice/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/tc` });
                    }
                    else if (this.selectedRows[0].ToDoType === 'Item Issue Request') {
                        this.$router.push({ path: `/issueSlip/${btoa(this.selectedRows[0].StaffId)}/${btoa(this.selectedRows[0].refid)}/${btoa(this.selectedRows[0].Id)}/tc` });
                    }
                }
            },
            selectChange(data) {
                this.selectedRows = data;
            },
            search(){
                this.pagination.page = 1;
                this.getData()
            },
            sortChange(data) {
                this.sorting.key = data.key;
                this.sorting.order = data.order;
                this.getData()
            },
            getData() {
                setTimeout(() => {
                    this.showLoader();
                    const { key, order } = this.sorting;
                    const { perPage, page } = this.pagination;
                    const data = {
                        filterjson: {
                            sort: [{ key, order }],
                            paging: [
                                {
                                    startIndex: page,
                                    pageSize: perPage
                                }
                            ]
                        }
                    };
                    getToDoList(data)
                        .then(this.handleResponse)
                        .catch(this.handleError)
                },
                50
                )
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getData()
            },
            handleResponse(response) {
                this.hideLoader();
                this.toDoList = response.data;
                this.pagination.total = response.NumberOfRecords;
            },
        }
    }
</script>

<style lang="scss" module>
    .pagination {
        margin: 10px 0 0;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        line-height: 26px;
    }

    .paginationText {
        margin: 0 20px;
    }

    .paginationButton {
        cursor: pointer;
        width: 26px;
        text-align: center;
        transition: background-color .2s ease-in-out,color .2s ease-in-out, box-shadow 200ms ease
    }

    .paginationButton:hover {
        background: #57a3f3;
        color: #fff;
        &:hover {
            box-shadow: 0 5px 11px 0 rgba(0,0,0,.18), 0 4px 15px 0 rgba(0,0,0,.15);
        }
    }
</style>
